import clsx from "clsx";
import Button from "../Button/Button";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  titleAlign?: "left" | "center";
  subtitle?: string;
  headerLeft?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
  actionButton?: string;
  onAction?: () => void;
  // New props for design only
  variant?: "default" | "expanded";
  subtitleVariant?: "default" | "expanded";
};

const Modal: React.FC<Props> = ({
  title,
  titleAlign = "center",
  subtitle,
  headerLeft,
  isOpen,
  onClose,
  children,
  className,
  actionButton,
  onAction,
  variant = "default",
  subtitleVariant = "default",
}) => {
  return isOpen ? (
    <>
      <div className="cx-fixed cx-inset-0 cx-bg-background-overlay-primary cx-z-40"></div>
      <div className="cx-fixed cx-z-50 cx-inset-0 cx-overflow-y-auto">
        <div className="cx-flex cx-items-center cx-justify-center cx-min-h-screen">
          <div
            className="cx-fixed cx-inset-0 cx-bg-gray-500 cx-opacity-90"
            onClick={onClose}
          ></div>
          <div
            className={`cx-relative cx-bg-background-default cx-rounded-modal cx-px-6 cx-py-10 max-md:cx-max-w-[343px] ${
              variant === "expanded" ? "cx-max-w-[480px]" : "cx-max-w-[420px]"
            } ${className}`}
          >
            <div className="cx-mb-6">
              {(headerLeft || (title && titleAlign === "left")) && (
                <div className="cx-flex cx-items-center cx-gap-3 cx-mb-3">
                  {headerLeft}
                  {title && titleAlign === "left" && (
                    <h2 className="cx-text-text-primary cx-font-bold cx-text-2xl">
                      {title}
                    </h2>
                  )}
                </div>
              )}
              {title && titleAlign !== "left" && (
                <h2 className="cx-text-text-primary cx-font-bold cx-text-2xl cx-text-center">
                  {title}
                </h2>
              )}
              {subtitle && (
                <p
                  className={clsx("cx-text-center cx-text-base", {
                    "cx-text-text-tertiary cx-mt-2":
                      subtitleVariant === "expanded",
                    "cx-text-text-secondary cx-mt-6":
                      subtitleVariant === "default",
                  })}
                >
                  {subtitle}
                </p>
              )}
            </div>
            {children}
            {!!actionButton && (
              <Button label={actionButton} onClick={onAction} fullWidth />
            )}
          </div>
        </div>
      </div>
    </>
  ) : null;
};

export default Modal;
